import { SETTING_FAIL, SETTING_REQUEST, SETTING_SUCCESS } from "../constats/setting.constant";

export const settingReducer = (state={}, action) => {
    switch (action.type) {
        case SETTING_REQUEST:
            return {
                loading: true
            };
        case SETTING_FAIL:
            return {
                loading: false,
                error: action.payload
            };
        case SETTING_SUCCESS:
            return {
                loading: false,
                data: action.payload
            };
        default:
            return state;
    }
}